
import React from 'react';

export const SoundAttribution = () => {
  return (
    <div className="text-xs text-muted-foreground mt-2 text-center">
      <p>
        Sound Effects by{" "}
        <a 
          href="https://pixabay.com/users/kaydream321-25150359/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=13752"
          className="underline hover:text-primary transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          kaydream321
        </a>{" "}
        from{" "}
        <a 
          href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=13752"
          className="underline hover:text-primary transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          Pixabay
        </a>
      </p>
    </div>
  );
};
